import React, { FC } from 'react';

import {
  Box,
  ComponentImage,
  ComponentLink,
  FeatureGrid,
  FeatureGridItem
} from '@lucid/components-react';
import {
  Drupal_ParagraphFeatureGridItem,
  Drupal_ParagraphFeatureGridSection,
  Drupal_ParagraphSeoImage
} from 'generated/drupal-graphql';
import { graphql } from 'gatsby';

interface FeatureGridSectionProps {
  entity: Drupal_ParagraphFeatureGridSection;
}

const FeatureGridSection: FC<FeatureGridSectionProps> = ({ entity }) => {
  const { fieldFeatureGridItems } = entity;

  const items = fieldFeatureGridItems?.reduce<FeatureGridItem[]>((previous, current) => {
    const currentItem = current.entity as Drupal_ParagraphFeatureGridItem;
    const currentImage = currentItem.fieldSectionImage?.entity as Drupal_ParagraphSeoImage;
    return [
      ...previous,
      {
        id: `${currentItem.id}`,
        cta: {
          linkUrl: currentItem.fieldCta?.url?.path,
          linkText: currentItem.fieldCta?.title
        } as ComponentLink,
        description: currentItem.fieldSectionDescription?.processed || '',
        image: {
          imageAlt: currentImage.fieldAltText,
          imageSrc: currentImage.fieldImageLink
        } as ComponentImage,
        title: currentItem.fieldTitle as string
      }
    ];
  }, []) || [];

  return (
    <Box
      gridColumn={{ default: '1 / -1' }}
      my={8}
    >
      <FeatureGrid items={items} variant="masonry" />
    </Box>
  );
};

export default FeatureGridSection;

export const query = graphql`
  fragment featureGridSection on Drupal_ParagraphFeatureGridSection {
    fieldFeatureGridItems {
      entity {
        ... on Drupal_ParagraphFeatureGridItem {
          id
          fieldCta {
            title
            url {
              path
            }
          }
          fieldSectionDescription {
            processed
          }
          fieldSectionImage {
            entity {
              ... on Drupal_ParagraphSeoImage {
                fieldAltText
                fieldImageLink
              }
            }
          }
          fieldTitle
        }
      }
    }
  }
`;
